// Displayed release. Bump the minor by 0.1 for every delivered feature (v1.9 → v1.10 → v1.11 …);
// bump the major only when the owner calls a major release. Also update public/explainer.html.
export const APP_VERSION = "1.15";
export const APP_CHANNEL = "Prod";
export const APP_RELEASE = `ECT-ODT · v${APP_VERSION} ${APP_CHANNEL}`;
